import React from 'react';
import { buildArrayIdFor, buildArrayNameFor, ListElementProps } from "../button/AddListElementButton";
import CloseButton from "../button/CloseButton";
import TextInput from "./TextInput";
import PhoneInput from "./PhoneInput";
import { useFormikContext } from "formik";
import { EmployeeFormValues } from "../common/EmployeeFormValues";

const TreatingPhysician = (props: ListElementProps) => {
    const { values } = useFormikContext<EmployeeFormValues>()
    const isAccidentBenefit = values.accident
    return (
        <>
            { props.index !== 0 && props.closeCallback && <CloseButton idPrefix="" index={props.index} closeCallback={props.closeCallback}/> }
            <TextInput id={buildArrayIdFor('physician-first-name', props)} name={buildArrayNameFor('physicianFirstName', props)}
                       label="Physician's first name" required={isAccidentBenefit} maxLength={1024}/>
            <TextInput id={buildArrayIdFor('physician-last-name', props)} name={buildArrayNameFor('physicianLastName', props)}
                       label="Physician's last name" required={isAccidentBenefit} maxLength={1024}/>
            <PhoneInput id={buildArrayIdFor('physician-phone-number', props)} name={buildArrayNameFor('physicianPhoneNumber', props)}
                        label="Physician's phone number" required={isAccidentBenefit}/>
        </>
    )
};

export default TreatingPhysician;